import { Button, Divider } from "antd";
import RemoveItemModal from "../shared/RemoveModal";
import { formatDateTime } from "../../lib/utils";
import { UserRole } from "../../lib/constants";

export default function ProjectTaskTile({ id, name, startDate, dueDate, assignee, refresh, onEdit, user }) {
    return (
        <div className="">
            <div className="w-full grid grid-cols-4 gap-2  pl-6 items-center justify-center  leading-[22px]">
                <div className="space-y-1 ">
                    <p>{name}</p>
                    <p className="text-sm text-gray-500">Assigned to <a href={`/users/${assignee.id}`} className="text-blue-500">{assignee.firstName + " " + assignee.lastName}</a></p>
                </div>
                <div className="flex space-x-1 ">
                    <p className="text-gray-500">Start Date:</p>
                    <p> {formatDateTime(startDate)}</p>
                </div>
                <div className="flex space-x-1">
                    <p className="text-gray-500">Due Date:</p>
                    <p> {formatDateTime(dueDate)}</p>
                </div>
                <div className=" flex justify-end pr-8">
                    {user?.role !== UserRole.AccountManager && (
                        <>
                            <Button type="link" onClick={() => RemoveItemModal({ type: "task", id: id, refresh })}>Remove</Button>
                            <Button type="link" onClick={() => onEdit(id)}>Edit</Button>
                        </>
                    )}
                </div>
            </div>
            <Divider />
        </div>
    )
}
